<template>
    <div class="result-hero-wrapper">
        <div class="container">
            <div class="col result-hero-container">
                <div class="result-hero-details" v-if="notice.system && notice.status">
                    <div class="details">
                        <div class="title">
                            <span class="greetingDetail"> {{ notice.system }} {{ notice.status }} </span>
                        </div>
                        <div class="details-description" v-if="notice.status !== 'operational'">
                            <span>{{ message }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useStore } from 'vuex'

// lodash components
import filter from 'lodash/filter'

export default {
    setup() {
        const store = useStore()
        return {
            store,
        }
    },
    props: ['message'],
    data() {
        return {
            notice: {
                system: null,
                status: null,
            },
            events: [],
        }
    },
    mounted: function () {
        this.store.subscribe((mutation, state) => {
            if (mutation.type === 'saveMonitors') {
                this.statusUpdate()
            }
        })
    },
    methods: {
        statusUpdate: function () {
            const monitors = this.store.getters.monitors()
            const total = monitors.length

            const ok = filter(monitors, monitor => monitor.uptime < 100 && monitor.uptime > 0).length
            const bad = filter(monitors, monitor => monitor.uptime === 0).length

            if ((ok > 0 && ok !== total) || (bad > 0 && bad !== total)) {
                this.notice.system = this.$t('status.systems.some')
            } else {
                this.notice.system = this.$t('status.systems.all')
            }

            if (ok > 0 && bad <= ok) {
                this.notice.status = this.$t('status.operation.ok')
            } else if (bad > 0) {
                this.notice.status = this.$t('status.operation.bad')
            } else {
                this.notice.status = this.$t('status.operation.good')
            }
        },
    },
}
</script>
